import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom'; // Import Link for navigation

const LandList = () => {
    const [landAssets, setLandAssets] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchLandAssets = async () => {
            try {
                const physicalResponse = await axios.get('/api/balance_sheet/assets/physical_assets/resi_properties/land');
                setLandAssets(physicalResponse.data);
            } catch (error) {
                console.error("Error fetching assets:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchLandAssets();
    }, []);

    if (loading) {
        return <div>Loading land assets...</div>;
    }

    return (
        <div className="land-assets-page">
        <div style={{ margin: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <h1 style={{ marginRight: '20px' }}>Land Assets</h1>
                <div>
                    <Link to="/assets/physical_assets/resi_properties"> Residential Property Assets</Link>
                </div>
            </div>
        </div>
            <table className="land-asset-table">
                <thead>
                    <tr>
                        <th>Asset ID</th>
                        <th>Legal Description</th>
                        <th>Residential Property</th>
                    </tr>
                </thead>
                <tbody>
                    {landAssets.length > 0 ? (
                        landAssets.map(land_asset => (
                            <tr key={land_asset.id}>
                                <td>
                                    <Link to={`/assets/physical_assets/resi_properties/land/${land_asset.id}`}>{land_asset.id}
                                    </Link>
                                </td>
                                <td>
                                    {land_asset.legal_description}
                                </td>
                                <td>
                                    <Link to={`/assets/physical_assets/resi_properties/${land_asset.residential_property}`}>
                                        {land_asset.residential_property}
                                    </Link>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="3" style={{ textAlign: 'center' }}>No land assets found.</td>
                        </tr>
                    )}
                </tbody>
            </table>
            <style jsx>{`
                .land-assets-page {
                    padding: 20px;
                    max-width: 800px;
                    margin: 0 auto;
                }
                .land-asset-table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-top: 20px;
                }
                .land-asset-table th, .land-asset-table td {
                    border: 1px solid #ccc;
                    padding: 10px;
                    text-align: left;
                }
                .land-asset-table th {
                    background-color: #f0f0f0;
                }
            `}</style>
        </div>
    );
};

export default LandList;